<template>
  <div>
    <vue-masonry-wall
      :items="items"
      :options="{width: columnWidth, padding: gap}"
      :gap="gap"
      class="social-step-editor-sidebar-media-images-masonry"
    >
      <template #default="{item}">
        <button
          type="button"
          :disabled="disabled"
          class="social-step-editor-sidebar-media-images-masonry__item"
          @click="onSelect(item)"
        >
          <img
            :src="item.thumbnail"
            alt=""
            class="social-step-editor-sidebar-media-images-masonry__img"
            :class="{
              'social-step-editor-sidebar-media-images-masonry__img--selected': item && image === item.src,
            }"
          />
        </button>
      </template>
    </vue-masonry-wall>
  </div>
</template>

<script>
import VueMasonryWall from 'vue-masonry-wall';

export default {
  components: {VueMasonryWall},
  props: {
    image: String,
    search: String,
    columnWidth: {
      type: Number,
      default: 100,
    },
    gap: {
      type: Number,
      default: 2,
    },
    disabled: Boolean,
  },
  data: () => ({
    items: [],
  }),

  methods: {
    fetchImages: _.debounce(function (value) {
      if (!value || value.length < 3) {
        this.items = [];
        return;
      }
      fetch(`https://pixabay.com/api/?key=10597407-60e755fce5dcf2a51b28036ac&q=${value}&image_type=photo`)
        .then(response => response.json())
        .then(data => {
          this.items = data.hits.map(item => {
            let {largeImageURL: largeImageUrl, previewURL: previewUrl} = item;
            return {
              src: largeImageUrl,
              thumbnail: previewUrl,
            };
          });
        })
        .catch(err => console.error(err));
    }, 500),
    onSelect(item) {
      this.$emit('selected', this.image === item?.src ? '' : item?.src);
    },
  },

  watch: {
    search(value) {
      this.fetchImages(value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../sass/web/_variables.scss';

.social-step-editor-sidebar-media-images-masonry {
  max-height: 300px;
  overflow: auto;
  &__item {
    width: 100%;
    cursor: pointer;
    background: transparent;
    border-radius: 4px;
    overflow: hidden;
    outline: none;
    padding: 0;
  }
  &__img {
    border: 2px solid transparent;
    width: 100%;
    display: block;
    &--selected {
      border: 2px solid $half-baked-color;
    }
  }
}
</style>
